export default __webpack_public_path__ + "static/media/money-back.2dbc2765.png";